export default {
    library_categories: "Categorías",
    library_file_not_found: "Archivo de biblioteca no encontrado",
    loading_files: "Cargando archivos",
    no_files_are_available_at_the_moment: "Actualmente no hay archivos disponibles",
    no_files_are_available_with_the_selected_filter: "No hay archivos disponibles para el filtro seleccionado"
}